/**
* Wild Salmon Center: Utilities
* http://wildsalmoncenter.org
*
* Copyright (c) 2015 Nate Bedortha @ Substance
*/

 var SubstanceWP = new function()
 {

 	var self = this;
 	var $ = jQuery;

 	this.timers = {};
 	this.doAfterDelayDefault = 250; // milliseconds
 	this.doAfterDelay = function( callback, uniqueId, ms )
 	{
 		if ( ! uniqueId )
 			uniqueId = self.get_random_string();
 		if ( ! ms )
 			ms = self.doAfterDelayDefault;
 		if ( self.timers[uniqueId] )
 			clearTimeout( self.timers[uniqueId] );
 		self.timers[uniqueId] = setTimeout( callback, ms );
 	};

 	this.readCookie = function( name )
 	{
 		var c = document.cookie.split('; '), cookies = {}, i, C;
 		for ( i = c.length - 1; i >= 0; i-- )
 		{
 			C = c[i].split('=');
 			cookies[C[0]] = C[1];
 		}
 		return cookies[name];
 	};

 	this.inView = function( element )
 	{
 		var winHeight = $(window).height();
 		var elePosition = element.offset().top;
 		return ( elePosition < winHeight );
 	};

 	this.get_post_id = function()
 	{
 		var classes = $('body').attr('class');
 		var matches = classes.match( /postid-(\d+)/ );
 		return ( matches ) ? matches[1] : null ;
 	};


 	this.get_tripadvisor_id = function()
 	{
 		var classes = $('body').attr('class');
 		var matches = classes.match( /tripadvisorid-(\d+)/ );
 		return ( matches ) ? matches[1] : null ;
 	};

 	this.get_random_string = function( length )
 	{
 		if ( ! length ) length = 7;
 		return Math.random().toString(36).substring( length );
 	};

  this.isInViewport = function( element ) {
    /**
    * var elem = document.querySelector('#some-element');
    * isInViewport(elem); // Boolean: returns true/false
    *
    */

      var distance = element.getBoundingClientRect();
      return (
          distance.top >= 0 &&
          distance.left >= 0 &&
          distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          distance.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
  };

 }
